<template>
    <!-- Modal Confirm changes -->
    <modal v-if="confirmModal" @close="confirmModalClose()" width="500px">
        <template slot="header">
            <h4 class="modal-title">Salvar Alterações</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="confirmModalClose()"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <div class="md-layout">
                <div
                    class="md-layout-item md-layout md-size-100 md-alignment-top-space-between"
                >
                    <div class="md-layout-item md-size-100 ">
                        <md-field>
                            <label>
                                Descreva o motivo das alterações dos parâmetros
                                (Opcional)
                            </label>
                            <md-textarea v-model="observation"></md-textarea>
                        </md-field>
                    </div>
                </div>
            </div>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="confirmModalClose()">
                Voltar
            </md-button>
            <md-button class="md-primary" @click="confirmModalSubmit()">
                <i
                    class="fas fa-spinner fa-spin"
                    v-if="confirmModalLoading"
                ></i>
                Confirmar
            </md-button>
        </template>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'
import { Modal } from '@/components'

export default {
    props: ['simulation'],
    components: {
        Modal
    },
    data() {
        return {
            confirmModal: false,
            confirmModalLoading: false,

            observation: ''
        }
    },
    methods: {
        ...mapActions('simulations', {
            executeSimulation: 'execute'
        }),

        // CONFIRM MODAL
        confirmModalOpen() {
            this.confirmModal = true
        },
        confirmModalClose() {
            this.confirmModal = false
        },
        async confirmModalSubmit() {
            if (!this.simulation.clone) return

            this.confirmModalLoading = true

            let response = await this.executeSimulation({
                id: this.simulation.clone,
                observation: this.observation
            })
            this.confirmModalLoading = false
            if (response === null) {
                this.$router.push(
                    '/product-simulation/' + this.simulation.product
                )
            }

            this.observation = ''
            this.confirmModalClose()
        }
    }
}
</script>
